var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['help-wrapper', _vm.isFixed ? 'fixed' : '']},[_c('div',{staticClass:"help"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('orderDetail.assistance'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }